module.exports = __webpack_public_path__ + "web-icons.f3d4e9aa32a77904f6fb.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/web-icons/web-icons.ttf?v=0.2.3
// module id = ../../../../../src/fonts/web-icons/web-icons.ttf?v=0.2.3
// module chunks = 5